(ns ductile.util.magic-wand)

(defn random-ars-id
  "Generates a real-world random ars id, for usage in dev & test"
  [_field]
  (let [ars-id-sample "0AKBZDF2000120001200012000152061"]
    (apply str (concat (take 10 ars-id-sample)
                       (take (- (count ars-id-sample) 10) (repeatedly #(rand-nth (range 10))))))))

(defn random-vin [_field] (apply str "DUCT4LE" (take 10 (repeatedly (fn [] (rand-nth (range 10)))))))

(def placeholder-pdf {:file/mime-type "application/pdf"
                      :cas/multihash "8VuzzfqhyiTpX46XDvJtv4KHMLfA3vA2xynXhpk5E4heV8LTvHn8J4NXLmWrvC7pE1f97jF8Rb3SxKPnY7jBmW7Q7Z"})

(def magic-wand-defaults
  {:vehicle/vin random-vin
   :ars/id random-ars-id
   :fahrzeug/vin-correct? true
   :fahrzeug/contract-known? false
   :entry/mode :mode/truck
   :entry/transport [:ductile/id #uuid "072c873f-04fe-456f-85a8-74e5e49dacf4"]
   :transport/ars-truck? true
   :transport/driver-name "Max Mustermann"
   :transport/number "ES042"
   :vehicle/engine-type :engine.type/plug-in-hybrid
   :vehicle/model "X1"
   :vehicle/permanently-quarantined? true
   :vehicle/new? false
   :vehicle/accident? false
   :vehicle/mileage 123
   :acceptance.conditions/day-or-night :day
   :acceptance.conditions/ice-&-snow? true
   :vehicle/license-plate "M-DUCK1"
   :vehicle/equipment (fn [{:as field :ui/keys [options]}] #{(first options)})
   :vehicle/hu-au-valid-until "12.29"
   :vehicle.status/battery-status :battery/charge-needed
   :vehicle.status/fuel-tank-percentage 50
   :vehicle.status/high-voltage-battery-status :battery/charge-needed
   :vehicle.status/hv-battery-charge-percentage 12
   :vehicle.status/battery-voltage 11
   :vehicle/stickers-larger-than-10x10cm? true
   :vehicle/tires (fn [{:as field :ui/keys [options]}] (first options)) #_:vehicle.tires/all-weather
   :vehicle/rims :vehicle.rims/aluminium
   :vehicle/extra-tires :vehicle.tires/none
   :vehicle/extra-rims :vehicle.rims/steel
   :vehicle/transport-protection-film-removed? true
   :vehicle/dirty-inside false
   :vehicle/dirty-outside false
   :document/uvv (assoc placeholder-pdf :file/name "uvv.pdf")
   :vehicle.status/high-voltage-battery-charge 72
   :photo/vehicle-left {:file/mime-type "image/png" :cas/multihash "8Vwy8X1W5oPNF8i5nBURRK9tpHAL1SwVdNWJtSncpBeGLLJphbWhXao32quS3YHYsoQ7LfZ7MFxSrH59ZKaWYWefT6"}
   :photo/vehicle-back {:file/mime-type "image/png" :cas/multihash "8VtuZBYrsk1FEXwYBHj2Q62QkG2fgTzjdymzXUGeWCLW1ZPToAP786NyWowEMbias7ywerhmgLj944sYst1VFifNMV"}
   :photo/vehicle-right {:file/mime-type "image/png" :cas/multihash "8VxLvr1h7xDxA2J4tTg8rkCkJQRwMG7wM24YFMXE35saDXsojM5sEJhaGfy5iB3XcbbEqfztEzzdjzuatM1fL6tj2p"}
   :photo/vehicle-front {:file/mime-type "image/png" :cas/multihash "8Vw3fzFutKD6rhjmMrG5aEYBzGA1JHyjMjsHsGYegedCPSD7m9ZwnME1p3YGzckDWeVJ2cmYiz42bqwNgmukKaLtT5"}
   :photo/vehicle-vin {:file/mime-type "image/png" :cas/multihash "8VxQqMFkH4VcMymtxvcnyjBzuzzUYxgkL5jN85BodCrFDYrxDypZYy5jfRx2intZAALzTa2EkdtNCkWvuN28VVGwkG"}
   :photo/cmr {:file/mime-type "image/png" :cas/multihash "8VxNGRe3SW6UfoJwtYfnY9Cym9Z52iA1tGEifPHMLXyymX1YgBNgDtKnFu1PBHoT6AfGVcvHBT1y5sJmkWHLrfFPYt"}
   :photo/damages [{:cas/multihash "8VujqJ6Lh5KUNzLRP1VvFTDiuFQw2YpzaHm6Bqk4TN7R48wxrmgwBPBM4ZVfL1UsU1eMUSawPvUWsVyW1ZgPtHwj6d"}
                   {:cas/multihash "8VwihK8d4Gq9zSEomFxEiLPTkfGescX3E2zzoWq2myJVzisTvMURBYyy4ivV6wPRcjmyC8m3kqAXGFwWk7vTiuK9iM"}]
   :photo/entstromung {:file/mime-type "image/png" :cas/multihash "8Vwab811Ahyq8e8D9Msa39igxXMikGSKCqaY8Dz7ot4giE3QAwdJWLyjVtS3P9zrtgQUFUbTfSByJv1EW7CnvYn1WB"}
   :photo/damage1 {:file/mime-type "image/png" :cas/multihash "8VujqJ6Lh5KUNzLRP1VvFTDiuFQw2YpzaHm6Bqk4TN7R48wxrmgwBPBM4ZVfL1UsU1eMUSawPvUWsVyW1ZgPtHwj6d"}
   :photo/damage3 {:file/mime-type "image/png" :cas/multihash "8VwihK8d4Gq9zSEomFxEiLPTkfGescX3E2zzoWq2myJVzisTvMURBYyy4ivV6wPRcjmyC8m3kqAXGFwWk7vTiuK9iM"}
   :photo/wheel-front-left {:file/mime-type "image/png" :cas/multihash "8VwRHwEc8abQL1FbAuiqd66UgDHZWaBP69YVLZDACbkMwGi74bTvsgXvT4uW5cX5oZpiBbnSvFwBsGvzsBwT9ZiAkW"}
   :photo/wheel-front-right {:file/mime-type "image/png" :cas/multihash "8VwRHwEc8abQL1FbAuiqd66UgDHZWaBP69YVLZDACbkMwGi74bTvsgXvT4uW5cX5oZpiBbnSvFwBsGvzsBwT9ZiAkW"}
   :photo/wheel-rear-left {:file/mime-type "image/png" :cas/multihash "8VwRHwEc8abQL1FbAuiqd66UgDHZWaBP69YVLZDACbkMwGi74bTvsgXvT4uW5cX5oZpiBbnSvFwBsGvzsBwT9ZiAkW"}
   :photo/wheel-rear-right {:file/mime-type "image/png" :cas/multihash "8VwRHwEc8abQL1FbAuiqd66UgDHZWaBP69YVLZDACbkMwGi74bTvsgXvT4uW5cX5oZpiBbnSvFwBsGvzsBwT9ZiAkW"}
   :photo/packed-wheel-set {:file/mime-type "image/png" :cas/multihash "8VvKiJUndnm8P4Dm37uDo8qXwojNs42YB1F6HwcDvyKNcKAvFs6a6P3kgJXieaMCQjUJLivhEQ5QBCM1fKpXWtA5Nn"}
   :entry-protocol/signature {:signature/place "Eitting"
                              :signature/signer "Max Mustermann"
                              :signature/datetime #inst "2026-04-23T10:56:13.970370317-00:00"
                              :signature/image {:file/mime-type "image/png" :cas/multihash "8Vwab811Ahyq8e8D9Msa39igxXMikGSKCqaY8Dz7ot4giE3QAwdJWLyjVtS3P9zrtgQUFUbTfSByJv1EW7CnvYn1WB"}}
   :transport/transporter
   [:ductile/id #uuid "5a0c60da-783f-47c2-b95d-cfb7e23b978a"]
   :transport/assumed-vehicles-count 2
   :transport/reuse-last-transport? false
   :service/quantity 5
   :fuel/type :fuel.type/diesel
   :vehicle.status/tire-pressure 2.2
   :sixt.tracker/serial-number "968539060252267"
   :sixt.tag/serial-number "980901681848325"
   :sixt.accessory/placement "Hinten: Kofferraum links"})

(defn magic-value [attr]
  (let [v (get magic-wand-defaults attr ::missing)]
    (if (fn? v)
      (v {})
      v)))
